import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import styles from './Videos.module.css'

interface Video { id: string; title: string; emoji: string; category: string; duration: number; color: string }

const CATEGORIES = ['All', 'Calming', 'Movement', 'Mealtime', 'Bedtime', 'Understanding', 'For Parents']
const CATEGORY_COLORS: Record<string, string> = { Calming: '#E8F5E9', Movement: '#FFF3E0', Mealtime: '#FFEBEE', Bedtime: '#E8EAF6', Understanding: '#FFF9C4', 'For Parents': '#F3E5F5' }

const VIDEOS: Video[] = [
  { id: '1', title: '3 Calming Activities You Can Do Anywhere', emoji: '', category: 'Calming', duration: 3, color: CATEGORY_COLORS.Calming },
  { id: '2', title: 'Bear Walks & Animal Movements', emoji: '', category: 'Movement', duration: 4, color: CATEGORY_COLORS.Movement },
  { id: '3', title: 'Making Mealtimes Stress-Free', emoji: '', category: 'Mealtime', duration: 5, color: CATEGORY_COLORS.Mealtime },
  { id: '4', title: 'The Perfect Bedtime Routine', emoji: '', category: 'Bedtime', duration: 4, color: CATEGORY_COLORS.Bedtime },
  { id: '5', title: 'What To Do During a Meltdown', emoji: '', category: 'Understanding', duration: 3, color: CATEGORY_COLORS.Understanding },
  { id: '6', title: 'Deep Pressure: Why Tight Hugs Help', emoji: '', category: 'Calming', duration: 2, color: CATEGORY_COLORS.Calming },
  { id: '7', title: '5 Focus Activities for Pre-Schoolers', emoji: '', category: 'Movement', duration: 5, color: CATEGORY_COLORS.Movement },
  { id: '8', title: 'Food Chaining: One Step at a Time', emoji: '', category: 'Mealtime', duration: 4, color: CATEGORY_COLORS.Mealtime },
  { id: '9', title: 'Oil Massage (Malish) for Better Sleep', emoji: '', category: 'Bedtime', duration: 3, color: CATEGORY_COLORS.Bedtime },
  { id: '10', title: "Why Your Child's Brain Can't Just Calm Down", emoji: '', category: 'Understanding', duration: 4, color: CATEGORY_COLORS.Understanding },
  { id: '11', title: 'Co-Regulation: Your Calm is Their Calm', emoji: '', category: 'For Parents', duration: 3, color: CATEGORY_COLORS['For Parents'] },
  { id: '12', title: 'Dressing Without Battles', emoji: '', category: 'Understanding', duration: 3, color: CATEGORY_COLORS.Understanding },
  { id: '13', title: 'Energy Release: Indoor Games for Rainy Days', emoji: '', category: 'Movement', duration: 5, color: CATEGORY_COLORS.Movement },
  { id: '14', title: 'Building Emotional Vocabulary', emoji: '', category: 'Understanding', duration: 4, color: CATEGORY_COLORS.Understanding },
  { id: '15', title: '2-Minute Reset for Overwhelmed Parents', emoji: '', category: 'For Parents', duration: 2, color: CATEGORY_COLORS['For Parents'] },
]

export default function Videos() {
  const navigate = useNavigate()
  const [filter, setFilter] = useState('All')
  const [toast, setToast] = useState(false)

  const filtered = filter === 'All' ? VIDEOS : VIDEOS.filter(v => v.category === filter)

  const handleClick = () => { setToast(true); setTimeout(() => setToast(false), 2000) }

  return (
    <div className={styles.container}>
      <header className={styles.header}>
        <button className={styles.backButton} onClick={() => navigate(-1)}>←</button>
        <h1 className={styles.title}>Watch & Learn</h1>
      </header>

      <div className={styles.filters}>
        {CATEGORIES.map(c => (
          <button key={c} className={`${styles.filterPill} ${filter === c ? styles.filterActive : ''}`} onClick={() => setFilter(c)}>{c}</button>
        ))}
      </div>

      <div className={styles.grid}>
        {filtered.map(v => (
          <button key={v.id} className={styles.videoCard} onClick={handleClick}>
            <div className={styles.thumbnail} style={{ backgroundColor: v.color }}>
              <span className={styles.thumbnailEmoji}>{v.emoji}</span>
              <div className={styles.playBtn}>▶</div>
              <span className={styles.durationBadge}>{v.duration} min</span>
              <span className={styles.comingSoon}>Coming soon</span>
            </div>
            <div className={styles.videoInfo}>
              <span className={styles.categoryTag}>{v.category}</span>
              <h3 className={styles.videoTitle}>{v.title}</h3>
            </div>
          </button>
        ))}
      </div>

      {toast && <div className={styles.toast}>Videos coming soon! We're working on it.</div>}
    </div>
  )
}
